<div class="print-container">
    <h1 class="page-label">Edgefinity Handheld - Seek And Find Operations </h1>
</div>


<div style="margin: 12px">
    
    <button (click)="onCreateNewClicked()" type="button" class="btn btn-ef" [disabled]="isRefreshingOperations">
        <em class="fa fa-plus"></em> CREATE NEW
    </button>

    <table class="table tablesorter tablesorter-default table-bordered table-hover" data-toggle="table" data-id-field="userid" role="grid">

        <thead>
            <tr role="row" class="tablesorter-headerRow">
                <!-- Label -->
                <th class="tablesorter-header tablesorter-headerUnSorted">
                    Label
                </th>

                <!-- RFID Encoding Type -->
                <th class="tablesorter-header tablesorter-headerUnSorted">
                    RFID Encoding Type
                </th>

                <!-- Main Property -->
                <th class="tablesorter-header tablesorter-headerUnSorted">
                    Main Property
                </th>

                <!-- Tag Property -->
                <th class="tablesorter-header tablesorter-headerUnSorted">
                    Tag Property
                </th>

                <!-- Enabled -->
                <th class="tablesorter-header tablesorter-headerUnSorted">
                    Enabled
                </th>
            </tr>
        </thead>

        <tbody>
            <tr *ngFor="let op of hhSeekAndFindOperations" role="row" (click)="onOperationRowClicked(op)">
                <!-- Label -->
                <td>
                    {{ op?.label }}
                </td>

                <!-- RFID Encoding Type -->
                <td>
                    {{ op?.encoding_type?.name }}
                </td>

                <!-- Main Property -->
                <td>
                    {{ op?.main_property?.name }}
                </td>

                <!-- Tag Property -->
                <td>
                    {{ op?.tag_property?.name }}
                </td>

                <!-- Enabled -->
                <td>
                    {{ op?.enabled }}
                </td>
            </tr>
        </tbody>

    </table>
</div>

<ef-hhseekandfind-dialog
    (cancelClicked)="onDialogCancelClicked()"
    (confirmClicked)="onDialogConfirmClicked()"
    >
</ef-hhseekandfind-dialog>

<!-- Simple Indefinite Dialog - Used to display a progress indicator when performing actions. -->
<ef-simple-indefinite-progress-dialog
    >
</ef-simple-indefinite-progress-dialog>

<!-- Simple Success Error Dialog Box - Displaying the Error generated for now since we dont display success msgs -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>